// 특정 호스트에서만 노출하는 기능의 판별 규칙 모음.
//   메뉴 노출(LeftNav)과 라우터 가드(router/index.js)가 같은 규칙을 쓰도록 여기에 모아둔다.

// NRW 메뉴를 보여줄 호스트 — 여기 없는 운영 도메인에서는 메뉴도 라우트도 막힌다
const NRW_HOSTS = ['id.neverlosewater.com']

// 로컬(개발) 접속인지 — dev 서버는 0.0.0.0 바인딩이라 LAN IP 로도 접속하므로 사설 IP 대역까지 로컬로 본다
function isLocalHost(hostname) {
  if (!hostname) return false
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === '[::1]') return true
  if (hostname.endsWith('.localhost')) return true
  // 사설 IP — 10.x.x.x / 192.168.x.x / 172.16~31.x.x
  if (/^10\./.test(hostname)) return true
  if (/^192\.168\./.test(hostname)) return true
  if (/^172\.(1[6-9]|2\d|3[01])\./.test(hostname)) return true
  return false
}

// 개발 빌드이거나 로컬/사설망 접속인지 — "운영 도메인에서만" 게이팅된 기능을 개발 중에는
//   풀어주기 위한 공통 판별. dev 서버는 0.0.0.0 바인딩이라 localhost / LAN IP 로 접속하므로
//   호스트 이름만으로는 운영과 같은 동작을 재현할 수 없다
export function isDevOrLocalHost() {
  if (typeof window === 'undefined' || !window.location) return false
  // 개발 빌드는 어디서 띄우든 로컬 작업으로 간주
  if (process.env.NODE_ENV !== 'production') return true
  return isLocalHost(window.location.hostname || '')
}

// NRW 메뉴 노출 여부 — 로컬이거나 호스트가 id.neverlosewater.com 인 경우만
export function isNrwVisible() {
  if (typeof window === 'undefined' || !window.location) return false
  if (isDevOrLocalHost()) return true
  return NRW_HOSTS.includes((window.location.hostname || '').toLowerCase())
}
